import StandardLayout from "./Standard";

export const DEFAULT_DESIGN_VARIANT = "standard";

// Registre local explicite : jamais d'import construit depuis une valeur stockée
// ou reçue dans l'URL. Ajouter ici les futures mises en page de présentation.
export const DESIGN_LAYOUTS = Object.freeze({standard: StandardLayout});

export function resolveDesignLayout(variant) {
    return typeof variant === "string" && Object.hasOwn(DESIGN_LAYOUTS, variant)
        ? DESIGN_LAYOUTS[variant]
        : DESIGN_LAYOUTS[DEFAULT_DESIGN_VARIANT];
}
